<mat-sidenav-container class="relative flex flex-grow h-full overflow-hidden bg-white">
    <mat-sidenav-content class="flex flex-col flex-grow">
        <section class="flex flex-col flex-grow m-30">
            <app-investment-policy-table [riaAccounts]="filteredAccounts" class="flex flex-col flex-grow m-30"></app-investment-policy-table>
            <div class="flex-grow w-full loader-wrap" *ngIf="isLoading" @fadeIn>
                <div class="loader-sm is-blue"></div>
            </div>
        </section>
    </mat-sidenav-content>
</mat-sidenav-container>